import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'puc-common-search',
  templateUrl: './common-search.component.html',
  styleUrls: ['./common-search.component.scss'],
  standalone: false
})
export class CommonSearchComponent {

  @Input() inputPlaceholder: string = '';
  @Output() searchText: any = new EventEmitter();
  @Output() clearSearch: any = new EventEmitter();
  @Output() enterKeyPress: EventEmitter<string> = new EventEmitter();

  /*  */
  search(searchValue: string) {
    this.searchText.emit(searchValue.trim());
  }

  /* clearFilterSearch method will emit the empty string */
  clearFilterSearch() {
    this.clearSearch.emit('');
  }

  onEnterPress(value: string) {
    const val = value.trim();
    val && this.enterKeyPress.emit(val);
  }
}
